import { mailingConstants } from "../actions/constants";

const initialState = {
    mailing: [],
    mailingObj: {},
    loading: false,
    sending: false,
    saving: false,
    sentEmails: [],
    senderKey: "",
    message: "",
    error: "",
    showAlert: false,
    variantAlert: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case mailingConstants.SEND_MAILING_REQUEST:
            return {
                ...state,
                sending: true,
                loading: true,
                message: "",
                error: "",
                showAlert: false,
                sentEmails: [],
                senderKey: "",
            };

        case mailingConstants.SEND_MAILING_SUCCESS:
            return {
                ...state,
                sending: false,
                loading: false,
                sentEmails: action.payload?.sentEmails || [],
                senderKey: action.payload?.senderKey || "",
                message: action.payload?.message || "Письмо отправлено",
                error: "",
                showAlert: true,
                variantAlert: "success",
            };

        case mailingConstants.SEND_MAILING_FAILURE:
            return {
                ...state,
                sending: false,
                loading: false,
                message: "",
                error: action.payload?.message || "Ошибка отправки письма",
                showAlert: true,
                variantAlert: "warning",
            };

        case mailingConstants.CREATE_AND_SEND_MAILING_REQUEST:
            return {
                ...state,
                sending: true,
                saving: true,
                loading: true,
                message: "",
                error: "",
                showAlert: false,
                sentEmails: [],
                senderKey: "",
            };

        case mailingConstants.CREATE_AND_SEND_MAILING_SUCCESS:
            return {
                ...state,
                sending: false,
                saving: false,
                loading: false,
                mailingObj: action.payload?.mailing || {},
                sentEmails: action.payload?.sentEmails || [],
                senderKey: action.payload?.senderKey || "",
                message: action.payload?.message || "Рассылка сохранена и отправлена",
                error: "",
                showAlert: true,
                variantAlert: "success",
            };

        case mailingConstants.CREATE_AND_SEND_MAILING_FAILURE:
            return {
                ...state,
                sending: false,
                saving: false,
                loading: false,
                message: "",
                error: action.payload?.message || "Ошибка сохранения и отправки рассылки",
                showAlert: true,
                variantAlert: "warning",
            };

        case mailingConstants.ADD_MAILING_REQUEST:
            return {
                ...state,
                saving: true,
                loading: true,
                message: "",
                error: "",
                showAlert: false,
            };

        case mailingConstants.ADD_MAILING_SUCCESS:
            return {
                ...state,
                saving: false,
                loading: false,
                mailingObj: action.payload?.mailing || {},
                message: action.payload?.message || "Рассылка сохранена",
                error: "",
                showAlert: true,
                variantAlert: "success",
            };

        case mailingConstants.ADD_MAILING_FAILURE:
            return {
                ...state,
                saving: false,
                loading: false,
                message: "",
                error: action.payload?.message || "Ошибка сохранения рассылки",
                showAlert: true,
                variantAlert: "warning",
            };

        case mailingConstants.GET_MAILING_REQUEST:
            return {
                ...state,
                loading: true,
                error: "",
            };

        case mailingConstants.GET_MAILING_SUCCESS:
            return {
                ...state,
                loading: false,
                mailing: action.payload?.mailing || [],
                error: "",
            };

        case mailingConstants.GET_MAILING_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.message || "Ошибка загрузки рассылок",
                showAlert: true,
                variantAlert: "warning",
            };

        case mailingConstants.GET_BY_ID_MAILING_REQUEST:
            return {
                ...state,
                loading: true,
                mailingObj: {},
                error: "",
            };

        case mailingConstants.GET_BY_ID_MAILING_SUCCESS:
            return {
                ...state,
                loading: false,
                mailingObj: action.payload?.mailing || {},
                error: "",
            };

        case mailingConstants.GET_BY_ID_MAILING_FAILURE:
            return {
                ...state,
                loading: false,
                mailingObj: {},
                error: action.payload?.message || "Ошибка загрузки рассылки",
                showAlert: true,
                variantAlert: "warning",
            };

        case mailingConstants.SET_CLOSE_ALERT:
        case mailingConstants.CLEAR_MAILING_STATUS:
            return {
                ...state,
                message: "",
                error: "",
                showAlert: false,
                variantAlert: "",
            };

        default:
            return state;
    }
};

export const setCloseAlertProductListLink = (payload) => ({
    type: mailingConstants.SET_CLOSE_ALERT,
    payload
});